
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    entries: { type: Array, required: true },
  },
  computed: {
    breakpoints() {
      return {
        1023: {
          perView: 2,
          peek: {
            before: 0,
            after: 0,
          },
        },
        639: {
          perView: 2,
          peek: {
            before: 0,
            after: 120,
          },
        },
        539: {
          perView: 1,
          peek: {
            before: 0,
            after: 120,
          },
        },
      }
    },
  },
})
